export const CyPlaylistItem = {
  EntryTitle: "EntryTitle",
  DragHandle: "DragHandle",
} as const;
